/* eslint-disable import/max-dependencies */
import { useNavigate, createSearchParams, Link } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardContent,
  Grid,
  Box,
} from "@mui/material";
import { useEffect } from "react";
import type React from "react";
import { getTableData } from "@fas/ui-framework";
import { getAccountList } from "../../actions/accountList";
import { ACCOUNT_LIST } from "../../helpers/constants";
import TitleSection from "./TitleSection";
import SearchSection from "./SearchSection";
import AccountSkeletonCard from "./AccountSkeletonCard";
import { getAccountsListLoading } from "../../selectors/loading";
import AccountCard from "./AccountCard";
import useHashId from "../../hooks/useHashId";
import type { State } from "../../pages/AppStoreWrapper";

export type AccountInfo = {
  name: string,
  domain: string,
  users: string[],
  id: string,
}

function IndexComponent() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const data: AccountInfo[] = useSelector((state: State) => getTableData(state, ACCOUNT_LIST));
  const isAccountsListLoading = useSelector(getAccountsListLoading);
  const {
    hashId, hashIdCookie, setHashId, removeHashId,
  } = useHashId();

  useEffect(() => {
    if (!hashId && hashIdCookie) {
      navigate({
        pathname: "/",
        search: `?${createSearchParams({
          hashId: hashIdCookie,
        }).toString()}`,
      });
    }
  }, [hashIdCookie]);

  const handleSearch = ({
    nameFilter,
    domainFilter,
    userFilter,
  }: {
    nameFilter: string;
    domainFilter: string;
    userFilter: string;
  }) => {
    dispatch(getAccountList({
      ...(nameFilter && { name: nameFilter }),
      ...(domainFilter && { domain: domainFilter }),
      ...(userFilter && { user: userFilter }),
    }));
  };
  const handleChoiceAccount = (id: string) => {
    removeHashId();
    setHashId(id);
    navigate({
      pathname: "/",
      search: `?${createSearchParams({
        hashId: id,
      }).toString()}`,
    });
  };
  const handleEditClick = (id: string) => {
    navigate(`/editAccount/${id}`);
  };

  return (
    <Box py={2}>
      {!hashId && (
        <>
          <TitleSection />
          <SearchSection handleSearch={handleSearch} isAccountsListLoading={isAccountsListLoading} />
          <Grid container alignItems="flex-start" justifyContent="center">
            {isAccountsListLoading && Array(10).fill("").map((i, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <Box key={idx} mb={1} px={1}>
                <AccountSkeletonCard />
              </Box>
            ))}
            {!isAccountsListLoading && (data.length || null)
                && data.map((i) => (
                  <Box key={i.id} mb={1} px={1}>
                    <AccountCard info={i} handleClickArea={handleChoiceAccount} handleEditClick={handleEditClick} />
                  </Box>
                ))}
          </Grid>
        </>
      )}
      {hashId && (
        <Box p={2} display="flex" alignItems="flex-start" justifyContent="space-around">
          <Card variant="outlined" sx={{ width: "350px", textAlign: "center", p: 1 }}>
            <CardContent>
              <Box mb={1}>
                <Link to={`/pages/list?hashId=${hashId}`}>Pages List</Link>
              </Box>
              <Box>
                <Link to={`/pages/create?hashId=${hashId}`}>Create page</Link>
              </Box>
            </CardContent>
          </Card>
          <Card variant="outlined" sx={{ width: "350px", textAlign: "center", p: 1 }}>
            <CardContent>
              <Box mb={1}>
                <Link to={`/redirects/list?hashId=${hashId}`}>Redirects List</Link>
              </Box>
              <Box>
                <Link to={`/redirects/create?hashId=${hashId}`}>Create redirect</Link>
              </Box>
            </CardContent>
          </Card>
          <Card variant="outlined" sx={{ width: "350px", textAlign: "center", p: 1 }}>
            <CardContent>
              <Box mb={1}>
                <Link to={`/linking/list?hashId=${hashId}`}>Linkings List</Link>
              </Box>
              <Box>
                <Link to={`/linking/create?hashId=${hashId}`}>Create linking</Link>
              </Box>
            </CardContent>
          </Card>
        </Box>
      )}
    </Box>
  );
}

export default IndexComponent;
